import { c as _c } from "react/compiler-runtime";
import type { GetHistoryEntry } from '@repo/schema/history';
import { cn } from '@repo/ui/lib/utils';
import type { ReactNode } from 'react';
import { ActionCell } from './history-action-cell.tsx';
import { ActorMeta } from './history-actor-meta.tsx';
import { HISTORY_WIDE_GRID_CLASS } from './history-constants.ts';
type HistoryRowProps = {
  children: ReactNode;
  className?: string;
  entry: GetHistoryEntry;
  title: string;
};

// Narrow/mid: action and actor share a header line with changes below.
// Wide: the same nodes are placed into the table columns.
export const HistoryRow = t0 => {
  const $ = _c(14);
  const {
    children,
    className,
    entry,
    title
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("grid min-w-0 grid-cols-[minmax(0,1fr)_fit-content(40%)] items-start gap-x-3 gap-y-3 px-3 py-3 @xl/history:px-4 @4xl/history:items-center @4xl/history:gap-x-2", HISTORY_WIDE_GRID_CLASS, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== entry || $[3] !== title) {
    t2 = <ActionCell className="col-start-1 row-start-1" entry={entry} title={title} data-sentry-element="ActionCell" data-sentry-source-file="history-row.tsx" />;
    $[2] = entry;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== entry) {
    t3 = <div className="col-start-2 row-start-1 min-w-0 @4xl/history:col-start-6"><ActorMeta entry={entry} data-sentry-element="ActorMeta" data-sentry-source-file="history-row.tsx" /></div>;
    $[5] = entry;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children) {
    t4 = <div className="col-span-2 grid min-w-0 gap-y-3 @4xl/history:col-span-4 @4xl/history:col-start-2 @4xl/history:row-start-1 @4xl/history:grid-cols-subgrid @4xl/history:gap-y-2">{children}</div>;
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className={t1} data-sentry-component="HistoryRow" data-sentry-source-file="history-row.tsx">{t2}{t3}{t4}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};